import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const Otp1 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const { mobile, uotp, name, email } = location.state || {};
  
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [error, setError] = useState("");
  
  const inputRefs = useRef([]);

  useEffect(() => {
    if (!mobile || !uotp || !name || !email) {
      alert("Invalid access. Please register again.");
      navigate("/register");
    }
  }, [mobile, uotp, name, email, navigate]);

  useEffect(() => {
    if (timer > 0 && !canResend) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setCanResend(true);
    }
  }, [timer, canResend]);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, value) => {
    if (loading) return;
    
    // Only allow single digit
    const digit = value.slice(0, 1);
    if (digit && !/^\d$/.test(digit)) return;
    
    const newOtp = [...otp];
    newOtp[index] = digit;
    setOtp(newOtp);
    setError("");

    // Move to next input
    if (digit && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (loading) return;
    
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
    
    // Allow arrow keys navigation
    if (e.key === "ArrowLeft" && index > 0) {
      e.preventDefault();
      inputRefs.current[index - 1]?.focus();
    }
    
    if (e.key === "ArrowRight" && index < 5) {
      e.preventDefault();
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    if (loading) return;
    
    const pastedData = e.clipboardData.getData("text").replace(/\D/g, "");
    if (pastedData.length === 6) {
      const otpArray = pastedData.split("");
      setOtp(otpArray);
      setError("");
      inputRefs.current[5]?.focus();
    }
  };

  const handleInputClick = (index) => {
    if (loading) return;
    inputRefs.current[index]?.focus();
    // Select the content
    inputRefs.current[index]?.select();
  };

  const verifyOTP = async () => {
    if (loading) return;
    const otpCode = otp.join("");
    //alert(otpCode+uotp);
    
    

    if (otpCode!=uotp) {
      setError("The OTP you entered is incorrect.");
      return;
    }

    setLoading(true);
    setError("");
    
    try {
      const formData = new FormData();
      formData.append("mobile", mobile);
      formData.append("name", name);
      formData.append("email", email);

      const response = await fetch("https://gtfundcrop.com/Rest5/web_otp_verify_api2", {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "application/json",
        },
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || "Verification failed");
      }

      if (data.status === "success" || data.lid) {
        navigate("/kyc-verification", { state: { userid: data.lid } });
      } else {
        setError(data.message || "Verification failed. Please try again.");
      }
      
    } catch (error) {
      setError(error.message || "Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const resendOTP = async () => {
    if (!canResend || loading) return;
    
    setCanResend(false);
    setTimer(30);
    setError("");
    
    try {
      const formData = new FormData();
      formData.append("mobile", mobile);
      formData.append("name", name);
      formData.append("email", email);

      const response = await fetch("https://gtfundcrop.com/Rest5/resend_otp_api", {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "application/json",
        },
      });

      const data = await response.json();
      
      if (data.status === "success") {
        alert("OTP resent successfully!");
        setOtp(["", "", "", "", "", ""]);
        inputRefs.current[0]?.focus();
      } else {
        setError(data.message || "Failed to resend OTP. Please try again.");
        setCanResend(true);
        setTimer(0);
      }
    } catch (error) {
      setError("Failed to resend OTP. Please try again later.");
      setCanResend(true);
      setTimer(0);
    }
  };

  return (
    <div className="min-vh-100 position-relative" style={{ backgroundColor: '#f8f9fa' }}>
      {loading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div className="bg-white p-4 rounded-4 text-center shadow-lg">
            <Spinner animation="border" variant="primary" style={{ width: 40, height: 40 }} />
            <div className="mt-3 text-secondary fw-semibold">Verifying OTP...</div>
          </div>
        </div>
      )}

      {/* Background Circles */}
      <div className="position-absolute top-0 start-0 w-100 h-100 overflow-hidden" style={{ pointerEvents: 'none' }}>
        <div className="position-absolute rounded-circle" style={{
          top: -80,
          left: -80,
          width: 160,
          height: 320,
          borderRadius: 120,
          backgroundColor: '#3B82F6',
          opacity: 0.3,
        }} />
        <div className="position-absolute rounded-circle" style={{
          bottom: -40,
          right: -40,
          width: 160,
          height: 400,
          borderRadius: 80,
          backgroundColor: '#3B82F6',
          opacity: 0.2,
        }} />
      </div>

      <div className="d-flex align-items-center justify-content-center min-vh-100 px-3">
        <div className="w-100" style={{ maxWidth: 450 }}>
          {/* Header */}
          <div className="text-center mb-4">
            <div className="p-3 rounded-4 border mx-auto" style={{
              borderColor: '#3B82F6',
              borderWidth: 0.3,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <h5 className="fw-semibold mb-1" style={{ color: '#333', fontSize: 16 }}>
                OTP Verification
              </h5>
              <p className="small text-secondary mb-0">
                We've sent a 6-digit code to {mobile}
              </p>
            </div>
          </div>

          {/* OTP Input */}
          <div className="mb-4">
            <label className="form-label fw-semibold small text-uppercase mb-2" style={{ color: '#64748B', fontSize: 10, letterSpacing: 0.5 }}>
              ENTER OTP
            </label>
            <div onPaste={handlePaste}>
              <div className="d-flex justify-content-between gap-2">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    className="text-center border rounded-2"
                    style={{
                      width: 50,
                      height: 50,
                      borderColor: error ? '#dc3545' : '#3B82F6',
                      fontSize: 18,
                      fontWeight: '600',
                      backgroundColor: loading ? '#e9ecef' : '#F8FAFF',
                      color: '#0F172A',
                      cursor: loading ? 'not-allowed' : 'text',
                      transition: 'all 0.2s ease',
                    }}
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onClick={() => handleInputClick(index)}
                    onFocus={(e) => e.target.select()}
                    inputMode="numeric"
                    autoComplete="off"
                    disabled={loading}
                  />
                ))}
              </div>
            </div>
            {error && (
              <div className="text-danger small mt-2 text-center" style={{ fontSize: '12px' }}>
                {error}
              </div>
            )}
          </div>

          {/* Submit Button */}
          <button
            className="btn w-100 py-3 fw-bold mb-3"
            style={{
              backgroundColor: loading ? '#93C5FD' : '#3B82F6',
              color: '#FFF',
              fontSize: 13,
              borderRadius: 10,
              letterSpacing: 0.5,
              transition: 'all 0.3s ease',
              boxShadow: loading ? 'none' : '0 2px 8px rgba(59,130,246,0.25)',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              border: 'none'
            }}
            onClick={verifyOTP}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" style={{ color: '#fff' }} className="me-2" />
                VERIFYING...
              </>
            ) : 'VERIFY OTP'}
          </button>

          {/* Resend */}
          <div className="text-center">
            <span className="small text-secondary">Didn't receive the OTP? </span>
            {canResend ? (
              <button
                className="btn btn-link p-0 text-decoration-none fw-semibold small"
                style={{ color: loading ? '#93C5FD' : '#3B82F6', cursor: loading ? 'not-allowed' : 'pointer' }}
                onClick={resendOTP}
                disabled={loading}
              >
                Resend Now
              </button>
            ) : (
              <span className="small text-secondary">Resend in {timer}s</span>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }
        
        input:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(59,130,246,0.25);
          border-color: #3B82F6;
        }
        
        input:disabled {
          background-color: #e9ecef;
          cursor: not-allowed;
        }
        
        .btn:focus {
          outline: none;
          box-shadow: none;
        }
        
        input[type="text"]::-webkit-inner-spin-button,
        input[type="text"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        
        input[type="text"] {
          -moz-appearance: textfield;
        }
      `}</style>
    </div>
  );
};

export default Otp1;